// extracted by mini-css-extract-plugin
export default {"containerLoader":"Loader_containerLoader__gLYLB","ldsRoller":"Loader_ldsRoller__h+ajS","lds-roller":"Loader_lds-roller__uTzxl"};